import { render, staticRenderFns } from "./MedanView.vue?vue&type=template&id=b201a1a0"
import script from "./MedanView.vue?vue&type=script&lang=js"
export * from "./MedanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports